// extracted by mini-css-extract-plugin
export default {"btn_selectFile":"custom_primary_button_btn_selectFile__jd12K"};